import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import SentimentTooltip from 'components/SentimentTooltip'
import { getStaticImage } from 'utils/statics'

const UserAvatar = (props) => {
  const {
    avatar, channel, sentiment, avatarWidth, avatarHeight, channelWidth,
    channelHeight, onChangeSentiment, onErrorAvatar, isSandbox
  } = props

  return (
    <div
      className='user-avatar'
      style={{
        width: avatarWidth || '40px',
        height: avatarHeight || '40px'
      }}
    >
      <figure className='user-avatar__avatar'>
        <img
          src={avatar || getStaticImage('/icons/orange-brand/icon-avatar.svg')}
          alt='Avatar'
          onError={event => typeof onErrorAvatar === 'function' ? onErrorAvatar(event) : null}
        />
      </figure>
      {channel ? (
        <figure
          className='user-avatar__channel'
          style={{
            width: channelWidth || '20px',
            height: channelHeight || '20px'
          }}
        >
          <img
            src={getStaticImage(`/channels/orange-brand/${channel}-icon.svg`)}
            alt='Channel'
          />
        </figure>
      ) : null}
      {sentiment?.value ? (
        <div className='user-avatar__sentiment'>
          <SentimentTooltip
            value={sentiment.value}
            score={sentiment.score}
            isManual={!sentiment.sentimentList[sentiment.sentimentList.length - 1]?.score}
            onChange={value => typeof onChangeSentiment === 'function' ? onChangeSentiment(value) : null}
          />
        </div>
      ) : null}
      {
        isSandbox
          ? (
            <div className='user_avatar-sandbox_title'>
              {I18n.t('channel_sandbox_title')}
            </div>
          )
          : null
      }
    </div>
  )
}

export default UserAvatar
